import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { updateManagerTeamInput } from '@sorare/core/src/__generated__/globalTypes';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  UpdateManagerTeamMutation,
  UpdateManagerTeamMutationVariables,
} from './__generated__/useUpdateManagerTeam.graphql';

const UPDATE_MANAGER_TEAM_MUTATION = gql`
  mutation UpdateManagerTeamMutation(
    $input: updateManagerTeamInput!
    $withSo5FixtureSlug: Boolean!
    $so5FixtureSlug: String!
  ) {
    updateManagerTeam(input: $input) {
      managerTeam {
        id
        name
        hidden
        so5Leaderboard(so5FixtureSlug: $so5FixtureSlug)
          @include(if: $withSo5FixtureSlug) {
          slug
          so5LeaderboardGroup {
            slug
            mySo5LeaderboardContenders {
              slug
            }
          }
        }
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateManagerTeamMutation,
  UpdateManagerTeamMutationVariables
>;

export const useUpdateManagerTeam = () => {
  const [mutate, { loading }] = useMutation(UPDATE_MANAGER_TEAM_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  return {
    updateManagerTeam: async (
      input: updateManagerTeamInput,
      so5FixtureSlug?: string
    ) =>
      mutate({
        variables: {
          input,
          so5FixtureSlug: so5FixtureSlug || '',
          withSo5FixtureSlug: !!so5FixtureSlug,
        },
      }),
    loading,
  };
};
